<template>
   <section class="syxz">
     <h3 style="text-align:center;">验货须知</h3>
      <div v-html="msg"></div>
   </section>
</template>

<script>
import {
  getHostMsg
} from "@/Inspector_api/index";
export default {
   name:'syxz',
   data(){
       return {
            msg:''
       }
   },
   async created(){
     const result = await getHostMsg({name:'inspector_notice'});
     let {data,code} = result.data
     if(code == 200){
       this.msg = data.value
     }
   }
}
</script>

<style scoped>
  .syxz{
      padding: 20px;
      box-sizing: border-box;
  }
</style>